import { ROOT } from '../../constants/links'

const redirect = (url = ROOT) => window.location.assign(url || ROOT)

export default redirect
